module.exports = __webpack_public_path__ + "static/media/scoli1-2m.c7c8f81a.png";